module.exports = __webpack_public_path__ + "img/google-pay-logo-lg.74e1c603.svg";